import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
const shortcutBoxSize = 1.5;
const FlexContainer = styled.div `
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;
const Title = styled.span `
  font-size: ${({ size }) => size};
  flex: 1;
  padding: 5px 0;
  text-align: left;
`;
const Description = styled.p `
  padding-top: 1rem;
  font-size: 0.7rem;
  text-align: left;
`;
const ShortcutItem = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem;
  border: 1px solid;
  border-radius: 4px;
  height: ${shortcutBoxSize}rem;
  min-width: ${shortcutBoxSize}rem;
  margin-left: 5px;
  font-size: 0.75rem;
  font-weight: bold;
`;
const SubTitleItem = styled.div `
  position: relative;
  padding-left: 15px;
  box-sizing: border-box;

  &::before {
    position: absolute;
    top: ${shortcutBoxSize / 2}rem;
    left: 0;
    width: 10px;
    height: 1px;
    margin: auto;
    content: '';
    border-bottom: 1px solid;
  }

  &::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 1px;
    height: 100%;
    content: '';
    border-left: 1px solid;
  }

  &:last-child::after {
    height: ${shortcutBoxSize / 2}rem;
  }

  &:first-child {
    margin: 0;
  }
`;
export function TooltipHelpContent(props) {
    const { title, shortcuts = [], subTitles = [], description = '', link, style = {}, } = props;
    return (_jsxs("div", { style: {
            color: 'white',
            width: '250px',
            padding: '0.5rem',
            ...style,
        }, children: [_jsxs(FlexContainer, { children: [_jsx(Title, { size: "0.9rem", children: title }), _jsx(ShortCuts, { shortcuts: shortcuts })] }), _jsx(SubTitles, { items: subTitles }), (description || link) && (_jsxs(Description, { children: [description, link && (_jsx("a", { style: description ? { paddingLeft: '5px' } : {}, target: "_blank", href: link, rel: "noreferrer", children: "Learn more" }))] }))] }));
}
function ShortCuts({ shortcuts }) {
    return (_jsx("div", { style: {
            display: 'flex',
            textWrap: 'nowrap',
        }, children: shortcuts.map((key) => {
            return (_jsx(ShortcutItem, { children: _jsx("span", { children: key }) }, key));
        }) }));
}
function SubTitles({ items }) {
    if (!items || items.length === 0) {
        return null;
    }
    return (_jsx("ul", { style: {
            paddingLeft: '5px',
            listStyle: 'none',
        }, children: items.map(({ shortcuts = [], title }) => (_jsx(SubTitleItem, { children: _jsxs(FlexContainer, { children: [_jsx(Title, { size: "0.7rem", children: title }), _jsx(ShortCuts, { shortcuts: shortcuts })] }) }, title))) }));
}
//# sourceMappingURL=TooltipHelpContent.js.map